import React, { useMemo, useState, useRef, useEffect } from "react";
import { Table, Typography, Spin } from "antd";
import ConsolidatedReportsTable from "../../../../../components/ConsolidatedReportsTable/ConsolidatedReportsTable";
import CustomSelectWithFilter from "../../../../../components/Common/CustomSelect/CustomSelectWithFilter";
import { useDispatch, useSelector } from "react-redux";
import { getAllUnits } from "../../../../../redux/unitSlice/unitSlice";
import CustomPagination from "../../../../../components/Common/CustomPagination/CustomPagination";

const { Title } = Typography;

const yn = (status) =>
    status === "FILLED" ? "Y" : "P";

/* -------------------------
METRICS ROWS
------------------------- */

const METRICS = [
    {
        label: "Project Cost",
        field: "UNIT_PROJECT_COST_STATUS",
    },

    

     {
        label: "Operational Income",
        field: "UNIT_OPERATIONAL_INCOME_STATUS",
    },
    {
        label: "Apportioned Cost",
        field: "UNIT_APORTIONED_COST_STATUS",
    },

    {
        label: "Billing",
        field: "UNIT_BILLING_STATUS",
    },

    {
        label: "Cash Inflow",
        field: "UNIT_CASH_INFLOW_STATUS",
    },

    {
        label: "Cash Outflow",
        field: "UNIT_CASH_OUTFLOW_STATUS",
    },

   

];

/* -------------------------
BUILD TABLE DATA
------------------------- */

function buildMonitoringData(apiData) {

    if (!apiData?.length) return {
        columns: [],
        rows: []
    };


    /// ✅ Dynamic Unit Columns
    const unitColumns = [

        ...new Set(

            apiData.map(
                item => item.MNF_UNIT_NAME
            )

        )

    ].sort();


    /// GROUP PROJECTS
    const grouped = {};

    apiData.forEach(row => {

        if (!grouped[row.PROJ_NAME]) {

            grouped[row.PROJ_NAME] = [];

        }

        grouped[row.PROJ_NAME].push(row);

    });


    const rows = [];

    Object.entries(grouped)

        .forEach(([projectName, projectRows]) => {

            METRICS.forEach(

                (metric, index) => {

                    const unitCells = {};

                    /// blank default
                    unitColumns.forEach(

                        u => unitCells[u] = "-"

                    );


                    /// fill Y/N
                    projectRows.forEach(r => {

                        unitCells[r.MNF_UNIT_NAME]
                            =
                            yn(r[metric.field]);

                    });


                    rows.push({

                        key:
                            `${projectName}_${metric.label}`,

                        projectName,

                        particulars:
                            metric.label,

                        rowSpan:
                            index === 0
                                ? METRICS.length
                                : 0,

                        ...unitCells

                    });

                });

        });


    /// COLUMNS
    const columns = [

        {

            title: "Project Name",

            dataIndex: "projectName",

            width: 220,
            fixed: "left",
            onCell: (record) => ({

                rowSpan: record.rowSpan,

                style: {
                    fontWeight: 600,
                    verticalAlign: "middle",
                    textAlign: "center"
                }

            })

        },

        {

            title: "Parameters",

            dataIndex: "particulars",
            fixed: "left",
            width: 220,

            onCell: () => ({

                style: {
                    background: "#fafafa"
                }

            })

        },

        ...unitColumns.map(unit => ({

            title: unit,

            dataIndex: unit,

            align: "center",

            width: 100,

          render: (value) => {
  if (!value || value === "-") return "-";

  const isFilled = value === "Y";

  return (
    <span
      style={{
        color: isFilled ? "#16a34a" : "#dc2626", // green / red
        fontWeight: 600,
      }}
    >
      {value}
    </span>
  );
}

        }))

    ];

    return {

        columns,
        rows

    };

}


/* -------------------------
COMPONENT
------------------------- */

export default function DataFilledStatusTable({

    data,
    loading = false,
   


}) {
    const dispatch = useDispatch();
    const [isScrolling, setIsScrolling] = useState(false);
    const scrollTimeoutRef = useRef(null);
    const tableContainerRef = useRef(null);

    const {

        columns,
        rows

    } = useMemo(

        () => buildMonitoringData(data),

        [data]


    );
    
    const handleScroll = () => {
        // Show loading indicator immediately
        setIsScrolling(true);

        // Clear existing timeout
        if (scrollTimeoutRef.current) {
            clearTimeout(scrollTimeoutRef.current);
        }

        // Hide loading indicator after scrolling stops
        scrollTimeoutRef.current = setTimeout(() => {
            setIsScrolling(false);
        }, 500);
    };

    return (

        <div className="mt-2">
            {/* 
                        <Title level={5}>

                            Monitoring projects submission status

                        </Title> */}

            {/* API Data Loading Indicator */}
          
 
            {/* Horizontal Scroll Loading Indicator */}
            {!loading && isScrolling && (
                <div className="absolute top-2 right-2 z-10 bg-white bg-opacity-90 px-3 py-1 rounded-md shadow-md">
                    <Spin size="small" />
                    <span className="ml-2 text-sm text-gray-600">Scrolling...</span>
                </div>
            )}

            {!loading && (
                <div 
                    ref={tableContainerRef}
                    onScroll={handleScroll}
                    className="overflow-x-auto"
                >
                    <ConsolidatedReportsTable

                        bordered

                        // size="small"

                        pagination={false}

                        rowKey="key"

                        columns={columns}

                        dataSource={rows}
                        loading={loading}
                        
sticky
    scroll={{ 
        x: 'max-content',
        y: 600   // 👈 required for sticky header
    }}

                    />
                       {/* <CustomPagination
               totalItems={totalMonitoringSubmissionData}
                                                pageSize={pageSize}
                                                currentPage={currentPage}
                                                setCurrentPage={setCurrentPage}
            /> */}
                </div>
            )}

        </div>

    );

}